var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.component)?_c(_vm.component,_vm._b({tag:"component",on:{"AfterRendering":_vm.AfterRendering,"childevent":_vm.childevent}},'component',_vm.comData,false),[_vm._l((_vm.$slots),function(val,key){return _c('template',{slot:key},[_vm._t(key)],2)})],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63267712","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Sys/PCindex.vue
// module id = null
// module chunks = 